<template>
  <loading v-if="!dataLoaded"></loading>
  <v-container v-else-if="dataLoaded && sortedQuestions.length === 0" class="pb-default">
    <v-card flat class="my-10 mx-auto" width="400">
      <v-card-text>{{ $t('el.no_questions') }}</v-card-text>
      <v-card-actions justify-end>
        <v-btn text @click="$router.back()" color="primary">{{ $t('back') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
  <div v-else-if="dataLoaded">
    <v-carousel touchless v-model="currentQuestionIndex" :show-arrows="false" hide-delimiters height="100%">
      <v-carousel-item :value="i" v-for="(question, i) in sortedQuestions" :key="i" class="full-height scroll-container">
        <v-sheet class="fill-height scroll-container">
          <v-row class="fill-height" align="start" justify="center">
            <el-result v-if="question.type === 'result'" :module="elmx_moduleFromRoute" :questions="sortedQuestions"></el-result>
            <el-page
              v-else
              :module="elmx_moduleFromRoute"
              :question="question"
              :questionIndex="i"
              :questionsCount="sortedQuestions.length || 0"
              :showSolution="showSolution"
              @onPrevious="onPrevious"
              @onNext="onNext"
              class="pb-14"
            ></el-page>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ElPage from './ElearningPage';
import ElResult from './ElearningResult';
import constants from './constants';
import elearningMixin from './ElearningMixin';
import Loading from '@/components/container/Loading';

const ROUTES = constants.ROUTES;

export default {
  name: 'ELQuestion',
  mixins: [elearningMixin],
  components: {
    ElPage,
    ElResult,
    Loading,
  },
  props: {
    question: Object,
  },
  data() {
    return {
      currentQuestionIndex: null,
      answersValid: false,
      correctionEnabled: false,
    };
  },
  mounted() {
    let slideParam = this.$route.params.slideIndex;
    if (slideParam === 'result') {
      this.currentQuestionIndex = this.sortedQuestions.length || 0;
    } else if (!slideParam) {
      this.currentQuestionIndex = 0;
    } else {
      this.currentQuestionIndex = Number(this.$route.params.slideIndex);
    }
  },
  computed: {
    ...mapState('elearning', ['modulesById', 'questions', 'answers', 'userStateByModuleId', 'next', 'dataLoaded']),

    showSolution() {
      if (this.elmx_moduleFromRoute) {
        return this.elmx_moduleFromRoute.displaySolution == 1;
      }
      return false;
    },

    sortedQuestions() {
      let module = this.elmx_moduleFromRoute;
      if (module) {
        let questions = this.questions.filter((q) => q.module_id === module.id).sort((a, b) => a.sort - b.sort);
        // .concat({ type: 'result' });
        console.debug('sortedQuestions', JSON.stringify(questions, null, 2));
        return questions;
      }
      return [];
    },
    currentQuestion: {
      get() {
        return this.$store.state.elearning.currentQuestion;
      },
      set(value) {
        this.$store.commit('elearning/setCurrentQuestion', value);
      },
    },
  },
  methods: {
    onPrevious() {
      let module = this.elmx_moduleFromRoute;
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
        this.elmx_next(module, this.currentQuestionIndex);
      } else {
        this.$router.push({ name: ROUTES.HOME });
      }
    },

    onNext() {
      console.debug('onNext');
      let module = this.elmx_moduleFromRoute;
      if (this.currentQuestionIndex < this.sortedQuestions.length - 1) {
        this.currentQuestionIndex++;
        this.answersValid = false;
        this.elmx_next(module, this.currentQuestionIndex);
      } else if (this.currentQuestionIndex === this.sortedQuestions.length - 1) {
        console.debug('Finish module');
        let userState = this.userStateByModuleId[module.id];
        userState.status = constants.STATUS.finished;
        this.elmx_goToResult(module);
      }
    },
  },
  watch: {
    currentQuestionIndex(newValue, oldValue) {
      if (newValue < this.sortedQuestions.length && newValue >= 0) {
        this.currentQuestion = this.sortedQuestions[newValue];
      }
    },
  },
};
</script>
